import { CloseCircleOutlined } from "@ant-design/icons";
import React, { Component } from "react";
import { Row, Col, Select, Button } from "antd";
import { range, filterMethod } from "../helpers/utilities";
import moment from "moment";
const { Option } = Select;

interface State {
  year?: string;
  month?: string;
  day?: string;
}

interface Props {
  onChange?: (d: string) => void;
  initialValue?: string | null;
  limitTo18?: boolean;
  startYear?: number;
  disabled?: boolean;
  allowPastDates?: boolean;
}

class DateSelector extends Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {};
  }
  
  generateMonths(): JSX.Element[] {
    return [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ].map((month: string, index: number): JSX.Element => {
      return (
        <Option key={month} value={String(index + 1)}>
          {month}
        </Option>
      );
    });
  }

  generateDays(): JSX.Element[] {
    return range(1, 31).map((day: number): JSX.Element => {
      return (
        <Option key={day} value={day}>
          {day}
        </Option>
      );
    });
  }

  generateYears(limitTo18: boolean, startYear?: number, allowPastDates?: boolean): JSX.Element[] {
    let end;
    let start;
    if (limitTo18) {
      start = moment().subtract(100, "year").year();
      end = moment().subtract(18, "year").year();
    } else if (allowPastDates) {
      start = moment().subtract(120, "year").year();
      end = moment().year();
    } else {
      start = startYear ? startYear : moment().year();
      end = moment().add(30, "year").year();
    }
    return range(start, end).map((year: number): JSX.Element => {
      return (
        <Option key={year} value={year}>
          {year}
        </Option>
      );
    });
  }

  handleMonthChange = (value: string): void => {
    this.setState({ month: value });
    this.handleChange("month", value);
  };

  handleDayChange = (value: string): void => {
    this.setState({ day: value });
    this.handleChange("day", value);
  };

  handleYearChange = (value: string): void => {
    this.setState({ year: value });
    this.handleChange("year", value);
  };

  handleChange = (type: string, value: string): void => {
    if (this.props.onChange) {
      let { year, month, day } = this.state;
      if (type === "year") {
        year = value;
      } else if (type === "month") {
        month = value;
      } else {
        day = value;
      }
      if (year && month && day) {
        this.props.onChange(
          moment(`${year}-${month}-${day}`, "YYYY-MM-DD").format(),
        );
      }
    }
  };

  handleClear = (): void => {
    this.setState({ year: undefined, month: undefined, day: undefined });
    this.props.onChange && this.props.onChange("");
  };

  componentDidMount(): void {
    const { initialValue } = this.props;
    if (initialValue) {
      const dateString = moment(initialValue).format("YYYY-MM-DD");
      const [year, month, day] = dateString.split("-");
      this.setState(
        {
          month: String(parseFloat(month)),
          day: day,
          year: year,
        },
        (): void => {
          this.props.onChange &&
            this.props.onChange(
              moment(`${year}-${month}-${day}`, "YYYY-MM-DD").format(),
            );
        },
      );
    }
  }

render(): JSX.Element {
    const { year, month, day } = this.state;
    const { disabled, allowPastDates } = this.props; 

    return (
      <Row>
        <Col span={9}>
          <Select
            placeholder="Day"
            value={day}
            style={{ width: "100%" }}
            showSearch
            onChange={this.handleDayChange}
            filterOption={true}
            disabled={disabled}
          >
            {this.generateDays()}
          </Select>
        </Col>

        <Col span={7}>
          <Select
            placeholder="Month"
            value={month}
            style={{ width: "100%" }}
            showSearch
            onChange={this.handleMonthChange}
            filterOption={filterMethod}
            disabled={disabled}
          >
            {this.generateMonths()}
          </Select>
        </Col>

        <Col span={7}>
          <Select
            placeholder="Year"
            value={year}
            style={{ width: "100%" }}
            showSearch
            onChange={this.handleYearChange}
            filterOption={true}
            disabled={disabled}
          >
            {this.generateYears(!!this.props.limitTo18, this.props.startYear, allowPastDates)}
          </Select>
        </Col>
        <Col span={1}>
          <Button onClick={this.handleClear} disabled={disabled}>
            <CloseCircleOutlined />
          </Button>
        </Col>
      </Row>
    );
  }
}
export default DateSelector;